import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '@/constants/company';

const stats = [
  { value: '1,200+', label: '累計成約件数' },
  { value: '98%', label: 'お客様満足度' },
  { value: '16区', label: '名古屋全域対応' },
  { value: '最短7日', label: '現金化スピード' },
];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e60857fdbd13b78da25da3703a3e0e74.jpg"
          alt="名古屋の高級住宅街"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D1B2E]/90 via-[#0D1B2E]/70 to-[#0D1B2E]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2E]/60 via-transparent to-transparent" />
      </div>

      {/* Decorative line */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-emerald-400/60 to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-12 pt-28 pb-20">
        <div
          className={`max-w-3xl transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Badge */}
          <div className="flex items-center gap-3 mb-8">
            <div className="h-px w-10 bg-emerald-400" />
            <span className="text-emerald-400 text-xs font-semibold tracking-[0.25em] uppercase">
              名古屋西区・16区に強い不動産会社
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-white font-bold leading-[1.1] mb-6">
            <span className="block text-4xl md:text-6xl lg:text-7xl mb-2">
              名古屋西区の不動産
            </span>
            <span className="block text-4xl md:text-6xl lg:text-7xl text-emerald-400">
              売却・買取・査定
            </span>
          </h1>

          <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-xl">
            名古屋西区を中心に16区全域対応。<br />
            相続・空き家・住み替え・急な現金化まで。<br />
            秘密厳守・押し売りなし・AI査定約60秒。
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={COMPANY.telHref}
              className="group inline-flex items-center justify-center gap-3 bg-emerald-500 hover:bg-emerald-400 text-white px-8 py-4 rounded-full font-bold text-base whitespace-nowrap transition-all duration-300 cursor-pointer"
            >
              <i className="ri-phone-line text-lg" />
              今すぐ電話でご相談
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200" />
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-3 border border-white/40 text-white px-8 py-4 rounded-full font-medium text-base whitespace-nowrap hover:bg-white/10 hover:border-white/70 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-mail-line" />
              メールで相談する
            </Link>
          </div>
        </div>

        {/* Stats Bar */}
        <div
          className={`mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden transition-all duration-1000 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {stats.map((stat, i) => (
            <div key={i} className="bg-white/5 backdrop-blur-sm px-6 py-5 text-center hover:bg-white/10 transition-colors duration-200">
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-white/50 text-xs tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Trust badges bottom */}
      <div className="absolute bottom-8 left-0 right-0">
        <div className="max-w-7xl mx-auto px-4 md:px-12 flex flex-wrap items-center gap-6">
          {[
            { icon: 'ri-shield-check-line', text: '宅建免許取得済' },
            { icon: 'ri-lock-line', text: '秘密厳守' },
            { icon: 'ri-global-line', text: '全国相談OK' },
            { icon: 'ri-hand-heart-line', text: '押し売りなし' },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/50 text-xs">
              <i className={`${badge.icon} text-emerald-400`} />
              {badge.text}
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 md:right-12 flex flex-col items-center gap-2 text-white/30">
        <span className="text-[10px] tracking-[0.2em] rotate-90 mb-4">SCROLL</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/30 to-transparent" />
      </div>
    </section>
  );
}